import Head from "next/head"
import dynamic from "next/dynamic"
import { useIntl } from "react-intl"

const ScanPage = dynamic(
  () => import("../../containers/Scan/Page").then((m) => m.ScanPage),
  { ssr: false },
)

export default function ScanRoute() {
  const intl = useIntl()

  return (
    <>
      <Head>
        <title>
          {intl.formatMessage({
            defaultMessage: "Scanner un QR code",
          })}
        </title>
      </Head>

      <ScanPage />
    </>
  )
}
